var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 22.5469H5.67188C5.11243 22.5469 4.57591 22.3246 4.18032 21.9291C3.78474 21.5335 3.5625 20.9969 3.5625 20.4375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 1.45312C5.62908 1.45313 4.91371 1.74944 4.38626 2.27689C3.85882 2.80433 3.5625 3.5197 3.5625 4.26562V20.4375C3.5625 19.8781 3.78474 19.3415 4.18032 18.9459C4.57591 18.5504 5.11243 18.3281 5.67188 18.3281H19.7344C19.9209 18.3281 20.0997 18.254 20.2316 18.1222C20.3634 17.9903 20.4375 17.8115 20.4375 17.625V2.15625C20.4375 1.96977 20.3634 1.79093 20.2316 1.65907C20.0997 1.5272 19.9209 1.45312 19.7344 1.45312H6.375Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 22.5469V18.3281",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7637 13.5761L14.024 11.344C14.2877 11.0803 14.6453 10.9322 15.0182 10.9322C15.3911 10.9322 15.7487 11.0803 16.0124 11.344L16.5102 11.8418C16.7739 12.1055 16.922 12.4631 16.922 12.836C16.922 13.2089 16.7739 13.5665 16.5102 13.8302L16.079 14.2615C15.9077 14.4341 15.6946 14.5595 15.4605 14.6252C15.2263 14.6909 14.9791 14.6948 14.743 14.6365L13.9255 14.4321C12.3621 14.0418 10.9342 13.2336 9.79474 12.0941C8.65527 10.9547 7.84712 9.52679 7.4568 7.96333L7.25617 7.14771C7.19741 6.91215 7.20063 6.66539 7.26552 6.43144C7.33042 6.1975 7.45477 5.98434 7.62648 5.81271L8.05773 5.38146C8.32145 5.11783 8.67907 4.96973 9.05195 4.96973C9.42484 4.96973 9.78246 5.11783 10.0462 5.38146L10.544 5.87833C10.8076 6.14204 10.9557 6.49966 10.9557 6.87255C10.9557 7.24544 10.8076 7.60306 10.544 7.86677L8.30711 10.1168",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogs);
export default __webpack_public_path__ + "static/media/call-logs.5bf7990726e8dbb5d73c44177fac2b1f.svg";
export { ForwardRef as ReactComponent };